var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChequebancaire01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.9,20H9.1c-5,0-9.1,4-9.1,9v62c0,5,4.1,9.1,9.1,9.1h101.8c5,0,9.1-4.1,9.1-9.1V29C120,24,115.9,20,110.9,20z M8.9,32.2 c0-1.9,1.6-3.5,3.5-3.5h76.7c1.9,0,3.5,1.6,3.5,3.5V40c0,1.9-1.6,3.5-3.5,3.5H12.4c-1.9,0-3.5-1.6-3.5-3.5V32.2z M8.9,50h59.8 c1.3,0,2.3,1,2.3,2.3s-1,2.3-2.3,2.3H8.9c-1.3,0-2.3-1-2.3-2.3C6.6,51,7.6,50,8.9,50z M8.9,64.6c-1.3,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3 h59.8c1.3,0,2.3,1,2.3,2.3s-1,2.3-2.3,2.3H8.9z M112.3,83.1c-3.9,2.3-8.8,1.7-12.4-1.6c-1.8-1.6-2.2-1.6-4.2-0.2 c-1.3,1-2.6,2.1-4,3.1c-2.7,1.9-5.7,2.2-8.6,0.4c-1.8-1.1-3.5-2.5-5.2-3.9c-0.7-0.5-1.2-1.3-1.9-2c-2,2.4-4,4.6-6,6.8 c-0.7,0.7-1.4,1.5-2.2,2.2c-1.8,1.5-3.5,1.1-4.3-1c-0.7-1.7-1-3.5-1.5-5.2c-0.1-0.4-0.2-0.7-0.4-1.4c-0.9,2.6-1.8,4.8-2.6,7.1 c-0.4,1.2-1.2,1.9-2.5,1.8c-1.4-0.1-2.3-1.5-1.8-3c1.7-5,3.6-9.9,5.4-14.8c0.4-1,1.2-1.5,2.3-1.4c1.1,0.1,1.7,0.8,2,1.9 c0.8,3.5,1.6,7,2.4,10.7c0.5-0.4,0.8-0.7,1.1-1c2.1-2.4,4.2-4.8,6.3-7.2c1.4-1.5,2.5-1.4,4,0c1.9,2,3.9,4,6,5.8 c2.3,1.9,3.5,1.8,5.9,0c1.2-0.9,2.4-2,3.7-2.9c3.2-2.2,5.9-2.1,8.8,0.6c2.4,2.2,4.9,2.7,7.8,1.2c1.4-0.7,2.6-0.3,3.2,0.8 C114.1,81.1,113.7,82.4,112.3,83.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChequebancaire01);
export default __webpack_public_path__ + "static/media/cheque bancaire-01.a0ddc2ddf4709f656fed76b4ee97911e.svg";
export { ForwardRef as ReactComponent };